import { render } from "./CIS-Masthead-With-Label.vue?vue&type=template&id=78ea72de&scoped=true"
import script from "./CIS-Masthead-With-Label.vue?vue&type=script&lang=js"
export * from "./CIS-Masthead-With-Label.vue?vue&type=script&lang=js"

import "./CIS-Masthead-With-Label.vue?vue&type=style&index=0&id=78ea72de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ea72de"]])

export default __exports__